<template>
  <v-container>
    <v-row>
      <v-col>
        <v-alert color="error"
          ><div style="color:#FFFFFF;">You don't have permission to access this page</div></v-alert
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
};
</script>
